var digitsInput = document.getElementById('cultureShortsDigits');
var shortsColor = document.getElementById('cultureShortsColor').value;
var canvas = document.getElementById('CustomizerCanvas');
var ctx = canvas.getContext('2d');

// check values of custom properties to determine if add to cart btn can be activated
function cartBtnsValidation() {
    var add2CartBtn = document.getElementById('AddToCart');
    var inputVal = digitsInput.value;
    if (inputVal == '' || isNaN(inputVal)) {
        add2CartBtn.style = 'pointer-events:none;cursor:none;background-color:#d19ba5';
    } else {
        add2CartBtn.style = '';
    }
}

// canvas creation
function createCanvasDigits(color, number) {
  var digit1 = number.substring(0,1);
  var digit2 = number.substring(1,2);
  ctx.imageSmoothingQuality = "high";
  if(digit1 !== ""){
    ctx.clearRect(159, 408, 117, 117);
    var digit1Img = new Image();
    digit1Img.src = '//www.miamiheatstore.com/cdn/shop/t/27/assets/' + color + '-' + digit1 + '.png';
    digit1Img.onload = function () {
        ctx.drawImage(digit1Img, 159, 408, 117, 117);
    };
  }else{
    ctx.clearRect(159, 408, 117, 117);
  }
  if(digit2 !== ""){
    ctx.clearRect(239, 407, 117, 117);
    var digit2Img = new Image();
    digit2Img.src = '//www.miamiheatstore.com/cdn/shop/t/27/assets/' + color + '-' + digit2 + '.png';
    digit2Img.onload = function () {
        ctx.drawImage(digit2Img, 239, 407, 117, 117);
    };
  }else{
    ctx.clearRect(239, 407, 117, 117);
  }
}

// customizer input fields key event listeners
function customizerKeyEvents() {
  digitsInput.addEventListener("keyup", function(event){
      var shortsNum = this.value;
      createCanvasDigits(shortsColor, shortsNum);
      cartBtnsValidation();
  });  

  // only allow digits
  digitsInput.addEventListener("keypress", function(event){
      var key = event.keyCode;
      if (key < 48 || key > 57) {
        event.preventDefault();
      }
  }); 
}

//init functions
customizerKeyEvents();
setTimeout(function () {
    cartBtnsValidation();
}, 300);